import React from 'react';
import { NavLink, Switch, Route, useRouteMatch } from 'react-router-dom';
import ReportsContainer from 'modules/reports/ReportsContainer';
import PaymentsContainer from 'modules/payments/PaymentsContainer';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';

import EGovernmentDashboard from './EGovernmentDashboard';

const EGovernment = () => {
  const match = useRouteMatch();

  const permissions = getJson('permissions');

  return (
    <div className="module-inner">
      <div className="module-inner-title">E-Government and E-Services Dashboard</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW E-GOVERNMENT']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/e-government"
          >
            Dashboard
          </NavLink>
        )}

        {Acl(permissions, ['VIEW REPORTS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-government/reports"
          >
            Reports
          </NavLink>
        )}

        {Acl(permissions, ['VIEW PAYMENT MENU']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-government/payments"
          >
            Payments
          </NavLink>
        )}

        {/* <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/e-government/deliveries"
        >
          Deliveries
        </NavLink> */}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={EGovernmentDashboard} />
        <Route path={`${match.path}/reports`} component={ReportsContainer} />
        <Route path={`${match.path}/payments`} component={PaymentsContainer} />
      </Switch>
    </div>
  );
};

export default EGovernment;
